(function() {
    'use strict';
    angular
        .module('emarket.main.navigation')
        .controller('NavigationController', ['$scope', '$mdPanel', '$log', '$document', '$rootScope', '$timeout', 'Favorite', 'Post', '$location', '$state', '$mdMedia', '$mdSidenav', 'Announcer', '$auth', 'Auth', 'Category', 'Suggestion', 'Socket', 'ProvinceChooser', 'Chat', function($scope,
            $mdPanel,
            $log,
            $document,
            $rootScope,
            $timeout,
            Favorite,
            Post,
            $location,
            $state,
            $mdMedia,
            $mdSidenav,
            Announcer,
            $auth,
            Auth,
            Category,
            Suggestion,
            Socket,
            ProvinceChooser,
            Chat) {
            var vm = this;
            vm.unreadMessages = 0;
            var announcer = Announcer.create($scope);
            vm.province = ProvinceChooser.get();
            // ProvinceChooser.openFirstTime().then(function(province) {
            //     vm.province = province;
            // });
            vm.suggestions = Suggestion.getLatest();
            vm.user = Auth.getUser();
            announcer.on(Auth.USER_CHANGE, function() {
                vm.user = Auth.getUser();
            });
            announcer.on(Chat.events.ON_SELECT_CHAT, function() {
                Chat.getUnreadMessageCount().then(function(response) {
                    vm.unreadMessages = response.unread;
                });
            });
            if ($auth.isAuthenticated()) {
                Chat.getUnreadMessageCount().then(function(response) {
                    vm.unreadMessages = response.unread;
                });
            }

            Socket.then(function(socket) {
                socket.on('chat', function(msg) {
                    announcer.emit(Announcer.types.CHAT_MESSAGE_RECEIVER, msg);
                    vm.unreadMessages += 1;
                });
            });
            vm.showCategories = function() {
                var panelPosition = $mdPanel
                    .newPanelPosition()
                    .absolute()
                    .top('122px')
                    .left('160px');

                $mdPanel.newPanelAnimation().withAnimation($mdPanel.animation.SCALE);
                var panelConfig = {
                    controller: 'CategoryBigMenuController as model',
                    resolve: {
                        categories: [
                            'Category',
                            function(Category) {
                                return Category.$search().$asPromise();
                            }
                        ]
                    },
                    position: panelPosition,
                    panelClass: 'category-big-menu',
                    disableParentScroll: true,
                    templateUrl: 'main/navigation-bar/categories/category-big-menu.tpl.html',
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    focusOnOpen: true,
                    hasBackdrop: true
                };
                $mdPanel.open(panelConfig);
            };
            if ($mdMedia('gt-sm')) {
                vm.navigationTemplate = 'main/navigation-bar/navigation-desktop.tpl.html';
            } else {
                vm.navigationTemplate = 'main/navigation-bar/navigation-mobile.tpl.html';
            }
            vm.categories = Category.$search({
                parentId: 0,
                $sort: {
                    name: 1
                }
            });
            vm.openContactDialog = function openContactDialog() {
                $scope.$emit('emarket.open-contact-dialog');
            };

            vm.showFilter = function() {
                announcer.emit(Post.events.SHOW_FILTER_DIALOG);
            };
            announcer.on(Post.events.SHOW_FILTER_BUTTON, function(ev, hide) {
                vm.showFilterButton = !hide;
            });
            announcer.on(Announcer.types.SHOW_BACK_BUTTON, function(ev, hide) {
                vm.showBackButton = !hide;
                $log.info('showing back button');
            });
            announcer.on(Announcer.types.HIDE_SEARCH_BAR, function(ev, hide) {
                vm.hideSearchBar = !hide;
            });
            vm.showProfileSidenav = function() {
                $timeout(function() {
                    $mdSidenav('sidenav-profile').toggle();
                }, 100);
            };
            vm.showNotificationSidenav = function() {
                $mdSidenav('sidenav-notification').toggle();
            };
            vm.showFavoriteSidenav = function() {
                $mdSidenav('sidenav-favorite').toggle();
            };
            vm.onBlurInput = function() {
                if (vm.searchText === '') {
                    vm.searchText = $location.search().q;
                }
            };
            vm.isMobile = $mdMedia('xs') || $mdMedia('sm');
            vm.currentNavigation = $state.current.name.match(/^\w+(\.\w+)?/)[0];
            var event = $rootScope.$on('$stateChangeSuccess', function(e,
                toState,
                toStateParams,
                fromState) {
                vm.currentNavigation = toState.name.match(/^\w+(\.\w+)?/)[0];
                if (
                    fromState.name === 'main.post.search' &&
          (toState.name !== 'main.post.detail' &&
            toState.name !== 'main.post.search.detail' &&
            toState.name !== 'main.post.search.detail-desktop')
                ) {
                    vm.searchText = '';
                }
                vm.showFilterButton = false;
                vm.hideSearchBar = false;
                vm.showBackButton = false;
            });

            vm.makeSearch = function(searchText) {
                $log.info('making text');
                Suggestion.add(searchText);
                $state.go('main.post.search', {
                    action: 'GET',
                    q: searchText
                });
                var autoComplete = angular.element($document[0].getElementById('md-search-autocomplete').firstElementChild);
                autoComplete.scope().$mdAutocompleteCtrl.hidden = true;
            };

            vm.searchText = $location.search().q;
            $scope.$on('$destroy', function() {
                event();
            });
        }]);
}());
